<template>
  <section class="app-container">
    <router-view></router-view>
  </section>
</template>

<script>
export default {
  name: 'appContent'
}
</script>




// WEBPACK FOOTER //
// src/containers/layouts/components/appContent.vue